
import { isEmbedMode } from "./embedMode";
import { decryptData } from "./api/encryption";

type LogPayload = Record<string, unknown>;

function format(payload: LogPayload): string {
  try {
    return JSON.stringify(payload);
  } catch {
    return "[unserializable]";
  }
}

export function embedAuth(step: string, payload: LogPayload = {}, always = false): void {
  if (!always && !isEmbedMode()) return;
  // eslint-disable-next-line no-console
  console.log(`[embed-auth] ${step}`, format(payload));
}

export function embedAuthWarn(step: string, payload: LogPayload = {}, always = false): void {
  if (!always && !isEmbedMode()) return;
  // eslint-disable-next-line no-console
  console.warn(`[embed-auth][warn] ${step}`, format(payload));
}

export function describeJwt(token: unknown): LogPayload {
  if (typeof token !== "string" || token.length === 0) {
    return { present: false, type: typeof token };
  }

  let decoded = token;
  let encrypted = false;
  try {
    const plain = decryptData(token);
    if (plain && plain !== token) {
      decoded = plain;
      encrypted = true;
    }
  } catch {
  }

  const segments = decoded.split(".");
  let expiresAt: string | null = null;
  let expired: boolean | null = null;
  try {
    const claims = JSON.parse(atob(segments[1].replace(/-/g, "+").replace(/_/g, "/")));
    if (typeof claims?.exp === "number") {
      expiresAt = new Date(claims.exp * 1000).toISOString();
      expired = Date.now() >= claims.exp * 1000;
    }
  } catch {
    expiresAt = null;
  }

  return {
    present: true,
    encrypted,
    storedLength: token.length,
    segments: segments.length,
    looksStructurallyValid: segments.length === 3,
    expiresAt,
    expired,
  };
}

export function readEmbedClaims(token: unknown): Record<string, any> | null {
  if (typeof token !== "string" || !token) return null;
  try {
    const plain = decryptData(token);
    const source = typeof plain === "string" && plain ? plain : token;
    const segments = source.split(".");
    if (segments.length !== 3) return null;
    return JSON.parse(atob(segments[1].replace(/-/g, "+").replace(/_/g, "/")));
  } catch {
    return null;
  }
}
